const Form086TC = {
    stepName: {
        statement: "重要事項",
        school: "學校資料",
        student: "參賽學生",
        teacher: "指導教師資料",
        confirmation: "確認",
    },
    errorMsg: {
        min4: "每隊必須有四名學生",
        max2: "一隊中最多只有兩名中二學生",
    },
    label: {
        note: "備註",
        statement: "個人資料收集聲明",
        certify: "本人已閱讀，明白及同意上述條款及細則",
        eligibility: "參賽資格",
        schoolNameE: "學校名稱（英文）",
        schoolNameC: "學校名稱（中文）",
        schoolTel: "學校聯絡電話",
        schoolFax: "學校傳真號碼",
        nameEnglish: "姓名（英文）",
        nameChinese: "姓名（中文）",
        level: "年級",
        mobile: "手提電話號碼",
        email: "電郵地址",
        nil: "（如不適用，請填上“NIL”）",
    },
    levelValue: {
        secondary1: "中一",
        secondary2: "中二",
    },

    noteList: [
        {
            text: "教育局會利用本表格所載的個人資料，用作處理是次比賽的報名、聯絡及統計分析的用途。",
        },
        {
            text: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        },
        {
            text: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局／部門／機構披露作上述用途。",
        },
        {
            text: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        },
        {
            text: '如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需透過電郵 (<a href="mailto: exoge@edb.gov.hk">exoge@edb.gov.hk</a>) 向教育局資優教育組提出。',
        },
        {
            text: '教育局承諾會確保一切個人資料均依照 《個人資料（私隱）條例》的有關條文處理。詳情請參閱《<a style="color: blue" href="https://www.edb.gov.hk/attachment/tc/about-edb/info/privacy-statement/EDB_PDPO_c.pdf" target="_blank" rel="noopener noreferrer">教育局—私隱政策及實務聲明</a>》。',
        },
        {
            text: '如有查詢，請致電 3698 3493 或電郵至 <a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a> 與魯泳斌先生聯絡。',
        },
        {
            text: '學校須通知學生及其家長／監護人，在比賽過程中，教育局及獲教育局授權的人士／團體將有機會進行拍攝或錄影，學生將有可能被拍攝或錄影。教育局可能會利用有關的照片或影片，以印刷或數碼形式作推廣用途。若學校或家長／監護人對有關安排有任何疑問，請電郵至<a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a>。',
        },
    ],
    eligibilityList: [
        {
            text: "1. 每間學校只能派出一隊隊伍參賽。",
        },
        {
            text: "2. 每隊必須有四名學生。",
        },
        {
            text: "3. 參賽學生必須是中一或中二學生，一隊中最多只有兩名中二學生。",
        },
    ],
};
export default Form086TC;
